<template>
  <div class="user-manage">
    <!-- tab切换 -->
    <div class="tab-top">
      <div class="switch-menu">
        <el-radio-group class="menu-name" v-for="(item, index) in menuList" :key="index" v-model="selectedTab"
          @change="toUrl(item.url)">
          <el-radio-button :label="item.name"></el-radio-button>
        </el-radio-group>
      </div>
    </div>

    <div class="form-container">
      <div class="flex">
        <span class="title">投资人：</span>
        <el-input class="white" clearable v-model="form.username" placeholder="请输入"></el-input>
        <el-button class="btn-blue" icon="el-icon-search" @click="searchList">搜索</el-button>
      </div>
      <div class="add-user" @click="openDrawer">
        <span class="add-rectangle"></span>
        <span>新增投资人</span>
      </div>
    </div>

    <!-- 用户列表 -->
    <div class="table-container">
      <div class="table">
        <el-table :data="tableList" style="width: 100%">
          <el-table-column prop="name" label="投资人"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="openid" label="微信ID"></el-table-column>
          <el-table-column prop="status" label="使用状态">
            <template slot-scope="scope">
              <div :class="`status${scope.row.status}`">{{ scope.row.statusVal }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button :disabled="scope.row.status===0" class="btn-text" type="text"
                @click="openMod(scope.row)">编辑</el-button>
              <el-button class="btn-text" type="text" @click="updateStatus(scope.row)">
                {{scope.row.status===0?'启用':'禁用'}}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 新增/编辑用户 -->
    <el-drawer :title="drawerTitle" :visible.sync="drawer" :wrapperClosable="false" :before-close="handleCloseDrawer">
      <el-form ref="invenstmentForm" :rules="invenstmentFormRules" :model="invenstmentForm">
        <div class="sub-title">基本信息</div>
        <el-form-item label="投资人" prop="name">
          <el-input v-model="invenstmentForm.name" class="white" placeholder="请输入投资人"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="invenstmentForm.phone" class="white" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <div class="sub-title">设置权限</div>
        <el-form-item label="管理范围" prop="warehouseIdList" v-if="drawer">
          <WarehouseProjectSelectMultiple
            :parentSelectWarehouseAndProject="invenstmentForm.parentSelectWarehouseAndProject"
            @getSelectWarehouseAndProject="getSelectWarehouseAndProject"></WarehouseProjectSelectMultiple>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="submitForm('invenstmentForm')">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import UserManage from "models/user-manage";
const userManage = new UserManage();
import roleMixins from '@/common/mixins/role.js'
import userManageMixins from '@/common/mixins/user-manage.js'
import WarehouseProjectSelectMultiple from '@/components/base/select/warehouse-project-select-multiple.vue'
export default {
  mixins: [roleMixins, userManageMixins],
  inject: ['reload'],
  components: {
    WarehouseProjectSelectMultiple
  },
  data() {
    // 此处自定义校验手机号码js逻辑
    var phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
    var validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空!'))
      }
      if (!phoneReg.test(value)) {
        callback(new Error('手机号格式有误'))
      } else {
        callback()
      }
    }
    return {
      selectedTab: '投资人管理',
      form: {
        username: ""
      },
      searchForm: {
        username: ""
      },
      tableList: [],
      invenstmentForm: {
        id: "",
        name: "",
        phone: "",
        // 选择的仓库和项目
        parentSelectWarehouseAndProject: []
      },
      invenstmentFormRules: {
        name: [{ required: true, message: "请输入投资人", trigger: "blur" }],
        phone: [
          { required: true, validator: validatePhone, trigger: "blur" }
        ],
      },

      drawer: false,
      drawerTitle: '新增',
    };
  },
  watch: {
    drawer: {
      handler(newVal) {
        if (!newVal) {
          this.invenstmentForm.id = "";
          this.invenstmentForm.name = "";
          this.invenstmentForm.phone = "";
          this.invenstmentForm.parentSelectWarehouseAndProject = [];
        }
      }
    }
  },

  activated() {
    this.selectedTab = '投资人管理'
  },
  created() {
    this.initInvenstmentList();
  },
  methods: {
    /** 
     * @desc 获取投资人管理列表
    */
    initInvenstmentList() {
      let name = this.searchForm.username;
      userManage.getInvestorList(name).then(res => {
        if (res.success) {
          let tableList = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.phone = value.telephone;
            obj.openid = value.openid;
            obj.status = value.status;
            obj.statusVal = value.status === 1 ? '已启用': '已禁用';
            tableList.push(obj);
          });
          this.tableList = tableList;
        }
      });
    },
    
    /** 
     * @desc 获取详情信息
    */
    initDetails(id) {
      userManage.getInvestorDetails(id).then(res => {
        if (res.success) {
          let { warehouseAndProjectResVoList } = res.result
          let arr = []
          warehouseAndProjectResVoList.map(i => {
            let obj = {}
            obj.id = i.warehouseId
            obj.name = i.warehouseName
            obj.checkAll = i.checkFlag == 1 ? true:false
            obj.isIndeterminate = i.checkFlag == 2 ? true:false
            obj.projectIdList = i.projectIdList
            arr.push(obj)
          })
          this.invenstmentForm.parentSelectWarehouseAndProject = arr
          this.drawer = true
        } else {
          this.$message.error(res.message);
        }
      });
    },

    searchList() {
      this.searchForm = this.form;
      this.initInvenstmentList();
    },

    /**
     * @desc 修改状态
     */
    updateStatus(row) {
      if (row.status == 1) {
        this.$confirm("关闭后，该用户账号将无法登录后台，请确认", "关闭", {
          confirmButtonText: "关闭",
          cancelButtonText: "取消",
          confirmButtonClass: 'btn-red',
          cancelButtonClass: 'btn-gray'
        }).then(() => {
          this.postUpdateStatus(row.id)
        });
      } else {
        this.$confirm("启用后，该用户账号变更为可登录后台状态，请确认", "启用", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          confirmButtonClass: 'btn-blue',
          cancelButtonClass: 'btn-gray'
        }).then(() => {
          this.postUpdateStatus(row.id)
        });
      }
    },

    /**
     * @desc 更新使用状态
     */
    postUpdateStatus(id) {
      userManage.postModInvestorStatus(id).then(res => {
        if (res.success) {
          this.initInvenstmentList();
        }
      });
    },

    openDrawer() {
      this.drawerTitle = '新增'
      this.drawer = true
    },

    handleCloseDrawer() {
      this.drawer = false
    },


    /**
     * @desc 编辑
     */
    openMod(row) {
      this.invenstmentForm.id = row.id;
      this.invenstmentForm.name = row.name;
      this.invenstmentForm.phone = row.phone;
      this.drawerTitle = '编辑'
      this.initDetails(row.id)
    },

    
    /**
     * @desc 获取已设置的仓库和项目
     */
    getSelectWarehouseAndProject(v) {
      this.invenstmentForm.parentSelectWarehouseAndProject = v
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let warehouseAndProjectReqVos = []
          this.invenstmentForm.parentSelectWarehouseAndProject.map(i => {
            let obj = {}
            obj.warehouseId = i.id
            obj.projectIdList = i.projectIdList
            warehouseAndProjectReqVos.push(obj)
          })
          if (this.invenstmentForm.id) {
            let id = this.invenstmentForm.id;
            let data = {};
            data.name = this.invenstmentForm.name;
            data.telephone = this.invenstmentForm.phone;
            data.warehouseAndProjectReqVos = warehouseAndProjectReqVos;
            userManage.postModInvestor(id, data).then(res => {
              if (res.success) {
                this.initInvenstmentList();
                this.handleCloseDrawer();
                this.$message.success("编辑成功");
                this.reload()
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let data = {};
            data.name = this.invenstmentForm.name;
            data.telephone = this.invenstmentForm.phone;
            data.warehouseAndProjectReqVos = warehouseAndProjectReqVos;
            userManage.postAddInvestor(data).then(res => {
              if (res.success) {
                this.initInvenstmentList();
                this.handleCloseDrawer();
                this.$message.success("新增成功");
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
  }
};
</script>
<style lang="scss">
@import '@/assets/style/layout/system/user-manage.scss';
</style>
